// extracted by mini-css-extract-plugin
module.exports = {"section":"how-you-benefit_section__--3YL","wrapper":"how-you-benefit_wrapper__2MOWE","item":"how-you-benefit_item__3X12Z"};